import React from 'react'

import { useTranslation } from 'next-i18next'

import {
  LocationInputWrapper,
  MobileOptionsWrapper as StyledMobileOptionsWrapper
} from './Options.styled'

interface MobileOptionsWrapperProps {
  onOpenModal: () => void
  settedValue: string
  settedStartDate: string
  settedEndDate: string
}

const MobileOptionsWrapper: React.FC<MobileOptionsWrapperProps> = ({
  onOpenModal,
  settedValue
}) => {
  const { t } = useTranslation('parkings')
  return (
    <StyledMobileOptionsWrapper
      data-test-id="options-wrapper"
      onClick={onOpenModal}
    >
      <LocationInputWrapper data-test-id="location-mobile-input">
        {settedValue || t('searchNearParking.search.placeholder')}
      </LocationInputWrapper>
    </StyledMobileOptionsWrapper>
  )
}

export default MobileOptionsWrapper
